import { render, staticRenderFns } from "./ExternalLinkModal.vue?vue&type=template&id=0400ff8a"
import script from "./ExternalLinkModal.vue?vue&type=script&lang=js"
export * from "./ExternalLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports